// @ts-nocheck
import { useCompatQuery } from './useApolloCompat';
import { REPORT_RESULT_QUERY } from '../graphql/operations';

export function useReportResult(id: string) {
  return useCompatQuery(REPORT_RESULT_QUERY, {
    variables: { id },
    skip: !id,
  });
}
